import React, { useState, useEffect, useContext } from 'react';
import { Box, FormControlLabel, Switch, Typography, Grid } from '@mui/material';
import { AppContext } from '../../../../context/AppContextProvider';
import ButtonComponent from '../../../../components/ButtonComponent';
import { useGetConfigByIdAsync, useUpdateConfigAsync } from '../../../../services/Configs/useMutation';

const FaceSyncManagementTab = () => {
  const { showSnackbar } = useContext(AppContext);
  const [useLegacyFaceSyncFlow, setUseLegacyFaceSyncFlow] = useState(false);

  const { mutateAsync: getConfigs } = useGetConfigByIdAsync();
  const { mutateAsync: updateConfigs, isLoading } = useUpdateConfigAsync();

  useEffect(() => {
    getConfigs()
      .then((data) => {
        setUseLegacyFaceSyncFlow(data?.faceSync?.useLegacyFaceSyncFlow ?? false);
      })
      .catch(() => {
        showSnackbar('Erro ao carregar configurações de sincronização de faces.', 'error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = () => {
    updateConfigs({
      data: {
        faceSync: { useLegacyFaceSyncFlow },
      },
    })
      .then(() => {
        showSnackbar('Configurações de sincronização de faces salvas com sucesso.', 'success');
      })
      .catch((error: any) => {
        showSnackbar(error?.response?.data?.Message || 'Falha ao salvar configurações.', 'error');
      });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Sincronização de Faces
      </Typography>

      <Typography variant="body1" sx={{ mt: 2, mb: 3 }}>
        Controla qual fluxo de sincronização facial os cadastros (Geral, Responsável, Aluno e Cliente) usam ao criar, editar ou excluir.
      </Typography>

      <Grid container spacing={2} sx={{ maxWidth: 600 }}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={useLegacyFaceSyncFlow}
                onChange={() => setUseLegacyFaceSyncFlow((prev) => !prev)}
              />
            }
            label={
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                  Usar fluxo de sincronização legado (síncrono)
                </Typography>
                <Typography variant="caption" color="textSecondary" display="block">
                  Ative apenas se o fluxo novo (assíncrono, com barra de progresso) apresentar problema pra este cliente. É um fallback operacional, não a opção recomendada.
                </Typography>
              </Box>
            }
          />
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }}>
          <ButtonComponent onClick={handleSave} loading={isLoading}>
            Salvar Configurações
          </ButtonComponent>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FaceSyncManagementTab;
